<template>
  <div class="regimen-element">
    <div class="item-container">
      <div class="image">
        <img :src="getImageURL(abr)">
        <div class="checked-item-background"/>
      </div>
      <div class="bottom-text text-capitalize"><p>{{ name }}</p></div>
    </div>
    <div
      v-if="description"
      class="description">
      <span>{{ description }}</span>
    </div>
    <div class="checked-item">
      <CheckSvg/>
    </div>
  </div>
</template>
<script>
import CheckSvg from "./SVG/CheckSvg";
export default {
    components: {CheckSvg},
    props: {
        abr: {
            type: String,
            required: true
        },

        name: {
            type: String,
            required: true
        },

        description: {
            type: String,
            default: null
        }
    },

    methods: {
        getImageURL(imgABR) {
            try {
                return require('@/assets/images/icons/' + imgABR + '.png');
            } catch (e) {
                return require('@/assets/images/no-image.png');
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/RegimenElement.vue